<template>
  <div class="cross-district-warning">
    <a-text as="h6">
      {{ $t('signUp.multiDistrictAccess') }}
    </a-text>
    <a-text as="p">
      {{ $t('signUp.studentsAreGroupedByDistrict') }}
    </a-text>
  </div>
</template>

<style scoped>
.cross-district-warning {
  background-color: #fffaf4;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #fde6cc;
  max-width: 375px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  margin: 16px 0;
}
</style>
